import axios from "axios";
import AlertsApi from "../../ui/template/Alert/AlertsApi";
import AuthorizeApi from "./Auth/AuthorizeApi";
import AppConfig from "./AppConfig";

class  MemberRequest {

    _query;
    _variables;
    _operationName;
    _pageAlerts;
    _formAlerts;
    _hasFile;
    _url;
    params;
    files;
    _onUploadProgress;

    constructor() {
        this._query = null;
        this._variables = null;
        this._operationName = null;
        this._pageAlerts = null;
        this._formAlerts = null;
        this.params = {};
        this.files = {};
        this._hasFile = false;
        this._hasParams = false;
        this._url=AppConfig.base_url+'/graphql/membership';
        this._onUploadProgress = null;
    }

    getConfig() {
        let token=localStorage.getItem('authToken');
        let headers={"Authorization": `Bearer ${token}` };
        if(this._hasFile){
            headers["Content-type"] =   "multipart/form-data";
        }
        let config={
            withCredentials: true,
            crossDomain: true,
            headers: headers,
        };
        if(this._onUploadProgress!== null){
            config['onUploadProgress']=this._onUploadProgress;
        }
        return config;
    }


    get query() {
        return this._query;
    }

    set query(value) {
        this._query = value;
    }

    addParams(name,value) {
        this.params[name]=value;
        this._hasParams = true;
    }

    addFiles(name,value) {
        this.files[name]=value;
        this._hasFile = true;
    }

    get variables() {
        return this._variables;
    }

    set variables(value) {
        this._variables = value;
    }

    get operationName() {
        return this._operationName;
    }

    set operationName(value) {
        this._operationName = value;
    }


    set pageAlerts(value) {
        this._pageAlerts = value;
    }

    set formAlerts(value) {
        this._formAlerts = value;
    }

    async send(callback, numberCall = 0,isGraphQl=true) {
        let res = false;
        try {
            let data ={};
            if(isGraphQl){
                data = {query: this._query, variables: this._variables, operationName: this._operationName};
            }
            if( this._hasParams ){
                data=Object.assign(data,this.params);
            }
            if(this._hasFile){
                const fd = new FormData();
                let property;
                for( property in data) {
                    fd.append(property,data[property]);
                }
                for( property in this.files ) {
                    fd.append(property,this.files[property]);
                }
                data=fd;
            }
            let response = await axios.post(this._url, data, this.getConfig());
            //console.log(response);
            if(isGraphQl) {
                if (response.hasOwnProperty("data")) {
                    AlertsApi(response.data, this._pageAlerts, this._formAlerts);
                    let authorize = AuthorizeApi(response.data);
                    if (authorize === true) {
                        if (response.data.hasOwnProperty("data")) {
                            res = callback(response.data.data, this);
                        }
                    } else {
                        if (authorize === "refreshToken") {
                            if (numberCall < 3) {
                                numberCall++;
                                res = await this.send(callback, numberCall)
                            }
                        }
                    }
                }
            }else{
                res = callback(response.data, this);
            }
        } catch (error) {
            res = false;
        }
        return res;
    }
}

export default MemberRequest;
